import Vue from 'vue'
import Router from 'vue-router'

// 解决vue-router在3.0版本以上重复报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/Home'], resolve),
          meta: {
            title: '首页',
            bgUrl: 'home_banner.png'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '信息预警',
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/demo',
          name: 'demo',
          component: resolve => require(['@/view/demo'],resolve),
          meta: {
            title: 'demo'
          }
        },
        {
          path: '/informationwarning',
          name: 'informationwarning',
          component: resolve => require(['@/view/InformationWarning'],resolve),
          meta: {
            title: '信息预警',
            bgUrl: 'xxyj_banner.png'
          }
        },
        {
          path: '/warningdetails',
          name: 'warningdetails',
          component: resolve => require(['@/view/WarningDetails'],resolve),
          meta: {
            title: '预警详情',
            bgUrl: 'xxyj_banner.png'
          }
        },
        {
          path: '/investmentcommerce',
          name: 'investmentcommerce',
          component: resolve => require(['@/view/InvestmentCommerce'],resolve),
          meta: {
            title: '投资商贸服务',
            bgUrl: 'tzsm_banner.png'
          }
        },
        {
          path: '/overseassecurity',
          name: 'overseassecurity',
          component: resolve => require(['@/view/OverseasSecurity'],resolve),
          meta: {
            title: '海外安全',
            bgUrl: 'hwaq_banner.png'
          }
        },
        {
          path: '/overseascommunities',
          name: 'overseascommunities',
          component: resolve => require(['@/view/OverseasCommunities'],resolve),
          meta: {
            title: '海外社群',
            bgUrl: 'hwsq_banner.png'
          }
        },
        {
          path: '/aboutus',
          name: 'aboutus',
          component: resolve => require(['@/view/AboutUs'],resolve),
          meta: {
            title: '关于我们',
            bgUrl: !navigator.userAgent.includes('Windows') ? 'gywm_banner.png' : 'gywm_banner.jpg'
          }
        },
        {
          path: '/safetynewsdetails',
          name: 'safetynewsdetails',
          component: resolve => require(['@/view/SafetyNewsDetails'],resolve),
          meta: {
            title: '快讯详情',
            bgUrl: 'xxyj_banner.png'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js